import { 
  ChefHat, 
  Bath, 
  Home, 
  Layers, 
  Warehouse, 
  Paintbrush, 
  Square, 
  Fence, 
  PlusSquare, 
  Droplet, 
  Hammer, 
  Wrench 
} from "lucide-react";
import { Card, CardContent } from "./ui/card";
import { services } from "../data/mock";
import { useNavigate } from "react-router-dom";

const iconMap = {
  ChefHat: ChefHat,
  Bath: Bath,
  Home: Home,
  Layers: Layers,
  Warehouse: Warehouse,
  Paintbrush: Paintbrush,
  Square: Square,
  Fence: Fence,
  PlusSquare: PlusSquare,
  Droplet: Droplet,
  Hammer: Hammer,
  Wrench: Wrench
};

export const Services = () => {
  const navigate = useNavigate();

  return (
    <section id="services" className="pt-32 pb-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our <span className="text-crimson-600">Services</span>
          </h2>
          <p className="text-lg text-gray-600">
            Comprehensive remodeling solutions for every part of your home. 
            Quality craftsmanship and attention to detail in every project.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card 
                key={service.id} 
                className="group hover:shadow-xl transition-all duration-300 border-2 hover:border-crimson-600 cursor-pointer"
              >
                <CardContent className="p-8">
                  <div className="flex items-start space-x-4">
                    <div className="flex-shrink-0">
                      <div className="w-14 h-14 bg-crimson-100 rounded-lg flex items-center justify-center group-hover:bg-crimson-600 transition-colors">
                        <IconComponent className="w-7 h-7 text-crimson-600 group-hover:text-white transition-colors" />
                      </div>
                    </div>
                    <div className="flex-1">
                      <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-crimson-600 transition-colors">
                        {service.title}
                      </h3>
                      <p className="text-gray-600 leading-relaxed">
                        {service.description}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* CTA Section */}
        <div className="mt-16 text-center">
          <p className="text-lg text-gray-700 mb-6">
            Don't see what you're looking for? We handle a wide range of remodeling projects!
          </p>
          <button
            onClick={() => navigate("/contact")}
            className="bg-crimson-600 hover:bg-crimson-700 text-white font-semibold px-8 py-4 rounded-lg shadow-lg hover:shadow-xl transition-all"
          >
            Contact Us About Your Project
          </button>
        </div>
      </div>
    </section>
  );
};
